import { getNavigationDepth, isTabRoot } from './navigation';

/** Stable key for storing main scroll position of a screen. */
export const getScrollRestoreKey = (pathname: string) => pathname;

export type ScrollRestoreDecision =
  | { action: 'keep' }
  | { action: 'top' }
  | { action: 'restore'; key: string };

/**
 * Decide how to set scrollTop after navigation.
 * Saves leaving page position separately via saveScrollPosition().
 */
export function resolveScrollRestore(
  prevPath: string,
  nextPath: string,
  navigationType: 'POP' | 'PUSH' | 'REPLACE',
): ScrollRestoreDecision {
  const prevDepth = getNavigationDepth(prevPath);
  const nextDepth = getNavigationDepth(nextPath);
  const nextKey = getScrollRestoreKey(nextPath);

  if (navigationType === 'POP' || nextDepth < prevDepth) {
    return { action: 'restore', key: nextKey };
  }

  if (nextDepth > prevDepth) {
    return { action: 'top' };
  }

  if (isTabRoot(nextPath)) {
    return { action: 'restore', key: nextKey };
  }

  if (prevPath !== nextPath) {
    return { action: 'restore', key: nextKey };
  }

  return { action: 'keep' };
}
